import { Session, SessionKeys } from 'common/services/-RFC.session.js';

const _serviceDependencies = ['$rootScope', '$state', '$location'];

/**
 * @ngdoc service
 * @name services.Redirect
 *
 * @description
 * This class is used to redirect routes (usually old routes)
 * to their new counterparts
 */
class Redirect {

    /**
     * @param {any} $rootScope $rootScope
     * @param {any} $state $state
     */
    constructor($rootScope, $state, $location) {

        this.$rootScope = $rootScope;
        this.$state = $state;
        this.$location = $location;

    }

    /**
     * @ngdoc function
     * @name services.Redirect#redirectUrl
     * @methodOf services.Redirect
     * @function
     *
     * @description
     * This method is used to redirect URLs (usually old ones)
     *
     */
    redirectUrl() {

        // redirects for URLs coming from login
        if (typeof this.$rootScope.loginUrlRedirect !== 'undefined') {


            if (this.$rootScope.loginUrlRedirect.indexOf('ltb/deploy/deviceType/pc') > -1) {

                this.$state.go('root.dashboard.devices.ltb.deploy', {
                    ltb: 'deploy',
                    resourceId: 'new',
                    os: 'windows',
                });

            } else if (this.$rootScope.loginUrlRedirect.indexOf('ltb/deploy/deviceType/phone') > -1 ||
                this.$rootScope.loginUrlRedirect.indexOf('ltb/deploy/svc/antitheft') > -1) {

                this.$state.go('root.dashboard.products.ltb.deploy', {
                    ltb: 'deploy',
                    resourceId: CWCONFIG.defaultDeployedAppId.android,
                    deviceId: 'new',
                });

            } else if (this.$rootScope.loginUrlRedirect.indexOf('ltb/my-profile') > -1) {

                /**
                 * my-profile redirects
                 */

                // subsection of my-profile redirect
                if (this.$rootScope.loginUrlRedirect.indexOf('/notifications') > -1) {

                    this.$location.path('/dashboard/my-account/tabs/notifications');

                } else if (this.$rootScope.loginUrlRedirect.indexOf('/change-password') > -1) {

                    this.$location.path('/dashboard/my-account/tabs/security');

                } else if (this.$rootScope.loginUrlRedirect.indexOf('/two-step-verification') > -1) {

                    this.$location.path('/dashboard/my-account/tabs/security');

                } else if (this.$rootScope.loginUrlRedirect.indexOf('/products') > -1) {

                    this.$state.go('root.dashboard.subscriptions', {
                        tab: 'plans',
                    });

                } else if (this.$rootScope.loginUrlRedirect.indexOf('/payment-history') > -1) {

                    this.$location.path('/dashboard/subscriptions/tabs/history');

                } else {

                    this.$location.url('/dashboard/my-account/tabs/profile');

                }

            } else if ((this.$rootScope.loginUrlRedirect.indexOf('subscriptions') > -1 &&
                        this.$rootScope.loginUrlRedirect.indexOf('deploy') === -1) ||
                        this.$rootScope.loginUrlRedirect.indexOf('url/deploy-pc') > -1 ||
                        this.$rootScope.loginUrlRedirect.indexOf('url/deploy-mobile') > -1) {

                if (this.$rootScope.loginUrlRedirect.indexOf('/otc') > -1) {

                    this.$state.go('root.dashboard.subscriptions', {
                        tab: 'plans',
                    });

                } else if (this.$rootScope.loginUrlRedirect.indexOf('history') > -1) {

                    this.$state.go('root.dashboard.subscriptions', {
                        tab: 'history',
                    });

                } else if (this.$rootScope.loginUrlRedirect.indexOf('expired') > -1) {

                    this.$state.go('root.dashboard.subscriptions', {
                        tab: 'plans',
                    });

                } else {

                    this.$state.go('root.dashboard.subscriptions', {
                        tab: 'plans',
                    });

                }

            } else if (this.$rootScope.loginUrlRedirect.indexOf('subscriptions') > -1 &&
                       this.$rootScope.loginUrlRedirect.indexOf('deploy') > -1) {


                /* if url contains subscriptions and deploy params, redirect to subscription page.
                After the user is redirected to subscription page, the deployment modal will
                be opened from "dashboard.es6" controller */

                // prevent redirect if the user is already on subscription page or set password page
                if (this.$state.current.name.indexOf('root.dashboard.subscriptions') === -1) {


                    const authExtraUrlParams =
                        Session.getValue(SessionKeys.ExtraUrlParams);

                    if (authExtraUrlParams && authExtraUrlParams.indexOf('/dashboard') > -1) {

                        const nextRoute = authExtraUrlParams.substring(authExtraUrlParams.indexOf('/dashboard'));

                        this.$location.url(`${nextRoute}`);


                    } else {

                        this.$state.go('root.dashboard.subscriptions', { tab: 'plans' });


                    }

                }

            } else {

                let newUrl = null;

                if (this.$rootScope.loginUrlRedirect.indexOf('/dashboard') > -1) {

                    newUrl = this.$rootScope.loginUrlRedirect.slice(this.$rootScope.loginUrlRedirect.indexOf('/dashboard'));

                    if (newUrl.indexOf('/ltb/notifications&') > -1) {

                        const newUrlReplace = newUrl.replace('notifications&', 'notifications?');
                        newUrl = newUrlReplace;

                    }

                    if (newUrl.indexOf('/my-account/tabs/payment&') > -1) {

                        const newUrlReplace = newUrl.replace('/my-account/tabs/payment&', '/my-account/tabs/payment?');
                        newUrl = newUrlReplace;

                    }

                    this.$location.url(newUrl);

                } else {

                    // when user comes from email
                    this.$state.go('root.dashboard.home');

                }

            }

        } else if (this.$location.path().indexOf('/auth/') >= 0) { // when no jwt

            this.$state.go('root.dashboard.home');

        }

    }


}

_serviceDependencies.push(Redirect);

angular.module('services')
    .service('Redirect', _serviceDependencies);



// WEBPACK FOOTER //
// ./scripts/services/Redirect.js